import React, { useEffect, useState, useCallback } from "react";
import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import VehicleLookup from "../../../../../shared/components/vehicleLookup";
import { fetchLicenceAuth } from "../../../../../shared/services/simpleListItemsService";
import useAppStateStore from "../../../../../shared/store/AppStateStore";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpVehicleMapper from "../mappers/spVehicleMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";

const SpVehicle = () => {
  const formMethods = useForm({
    defaultValues: SpVehicleMapper.get(),
  });
  const {
    register,
    formState: { errors, isValid },
    watch,
    setValue,
    control,
    trigger,
    handleSubmit,
  } = formMethods;

  const [lic, setlic] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let STATE = useAppStateStore();
  const navigate = useNavigate();

  const vehicleHireOptions = [
    {
      value: "private_hire",
      label: "Private Hire",
    },
    { value: "public_hire", label: "Public Hire/Hackney carriage" },
  ];
  const transmissionType = [
    {
      value: "manual",
      label: "Manual",
    },
    { value: "automatic", label: "Automatic" },
  ];

  const convertArrayFormat = useCallback((array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    fetchLicenceAuth()
      .then((uber) => setlic(uber))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (watch("prevManualVehicleReg")) {
      setValue("prevLookupVehicleReg", null);
    }
    if (watch("prevLookupVehicleReg")) {
      setValue("prevManualVehicleReg", null);
    }
  }, [watch("prevLookupVehicleReg"), watch("prevManualVehicleReg")]);

  const onSubmit = (data) => {
    SpVehicleMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-30">Change Vehicle</h1>
        <VehicleLookup STATE={STATE} prevVeh={true} formMethods={formMethods} />
        <RadioGroup
          name="exitingLicenseAuth"
          mainLabel="Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy?"
          register={register}
          errors={errors.exitingLicenseAuth}
        />
        {watch("exitingLicenseAuth") === "No" && (
          <LabelInput
            id="LicenseAuth"
            label="What will be the licencing authority?"
            type="select"
            options={convertArrayFormat(lic)}
            control={control}
            placeholder="Select licence authority"
            register={register("LicenseAuth", { required: true })}
            errors={errors.LicenseAuth}
            watch={watch("LicenseAuth")}
            trigger={trigger}
            isSearchable={true}
            isLoading={isLoading}
          />
        )}
        <LabelInput
          id="hireType"
          label="Will your vehicle be plated for Private hire or Public Hire/Hackney carriage?"
          type="select"
          options={vehicleHireOptions}
          control={control}
          errors={errors.hireType}
          placeholder="Select hire type"
          register={register("hireType", {
            required: "Required",
          })}
          watch={watch("hireType")}
          trigger={trigger}
        />
        <LabelInput
          id="transmissionType"
          label="Is your vehicle a Manual or Automatic?"
          type="select"
          options={transmissionType}
          control={control}
          errors={errors.transmissionType}
          placeholder="Select transmission type"
          register={register("transmissionType", {
            required: "Required",
          })}
          watch={watch("transmissionType")}
          trigger={trigger}
        />
        <NewDateTimePicker
          name="vehicleEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.vehicleEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("vehicleEffectiveDateTime")}
          minDate={new Date()}
        />
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpVehicle;
